module.exports = __webpack_public_path__ + "static/media/head-phones.32dfd12b.svg";